import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'ed-presentation-mode-webview-options',
  components: {
    EdNavMeetingsTools: () => import(/* EdNavMeetingsTools */'@/core/components/ed-nav-meetings-tools/ed-nav-meetings-tools.vue'),
    EdNavMeetingsMobile: () => import(/* EdNavMeetingsMobile */'@/core/components/ed-nav-meetings-mobile/ed-nav-meetings-mobile.vue'),
  }
})
export default class EdPresentationModeWebviewOptionsComponent extends Vue {

}